import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import axios from "axios";

// Global import of Font Awesome
import "!!style-loader!css-loader!font-awesome/css/font-awesome.css";
// Global import of Bootstrap 4
import "!!style-loader!css-loader!bootstrap/dist/css/bootstrap.css";
// Global import of React Tostify
import '!!style-loader!css-loader!react-toastify/dist/ReactToastify.css';

import "!!style-loader!css-loader!./index.css";
import App from "./App";
import WelcomePage from "./WelcomePage";
import Header from "./Header";
import LoadingBar from "react-top-loading-bar";
import DataService from "./DataService";

class Index extends React.Component {
  constructor(props) {
    super(props);

    axios.interceptors.request.use(
      config => {
        const { loading } = this.state;

        this.setState({
          loading: loading + 1
        });

        // Do something before request is sent
        return config;
      },
      function(error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      response => {
        const { loading } = this.state;

        this.setState({
          loading: Math.max(0, loading - 1)
        });

        // Do something with response data
        return response;
      },
      function(error) {
        // Do something with response error
        return Promise.reject(error);
      }
    );

    this.state = {
      loading: 0,
      company: "",
      email: "",
      isAdmin: false
    };
  }

  async componentWillMount() {
    const user = await DataService.getMe();
    if(user.permission.indexOf("admin") === -1) {
      window.location.href="https://my.visua.com/"
    }

    this.setState({
      company: user.developer.company,
      email: user.developer.email,
      isAdmin: user.developer.email.indexOf("logograb.com") !== -1 || user.developer.email.indexOf("visua.com") !== -1
    });
  }

  render() {
    const { loading, company, email, isAdmin } = this.state;

    return (
      <Router basename="/">
        <div>
          <Header email={email} />
          <LoadingBar loading={loading} />
          <Route
            exact
            path="/"
            render={() => (
              <WelcomePage
                company={company}
              />
            )}
          />
          <Route
            path="/activate/:brandRequestGroupId"
            render={props => <App {...props} isAdmin={isAdmin} />}
          />
          <ToastContainer />
        </div>
      </Router>
    );
  }
}

ReactDOM.render(<Index />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js